import React from 'react';
import { StyledMenu } from './index.styled';

export const MobileMenu = ({ open, children }) => <StyledMenu open={open}>{children}</StyledMenu>;
